<template>
    <span>
        <span class="card_method_number" v-if="getCardNumber">{{ getCardNumber }}</span>
        <img class="image-logo" :src="getCardLogoUrL" alt="logo"/>
    </span>
  </template>
  <script>
  export default {
      name: 'Email',
    props: {
      brand : {
        type: String,
        required: true,
      },
      last4 : {
        type : String,
        }
      },
    data() {
      return {
  
      };
    },
    methods : {
  
    },
    computed : {
        getCardLogoUrL () {
            if (this.brand === 'visa') {
                return require('@/assets/images/visa.png');
            } else if (this.brand === 'mastercard') {
                return require('@/assets/images/mastercard.png');
            } else if (this.brand === 'amex') {
                return require('@/assets/images/amex.png');
            } else if (this.brand === 'paypal') {
                return require('@/assets/images/paypal.png');
            } 
        },
        getCardNumber () {
            if (this.last4 != null)  {
                return `**** **** **** ${this.last4}`;
            }
            return `**** **** **** ****`;
            
            },
    },
    mounted(){
  
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  .image-logo {
    height:40px;
    margin-right: 10px;
    vertical-align:middle;
    }

    .card_method_number {
    font-size:16px;
    letter-spacing: 1px;
    vertical-align: middle;
    }

 
  </style>
  